export default __webpack_public_path__ + "static/media/video.a5298e0d.mp4";